import { gql } from '@apollo/client';

export const saveExitRulesMutation = gql`
  mutation SaveExitRules(
    $workflowId: Long!
    $workflowType: WorkflowType!
    $rules: [ExitRuleInputInput!]!
  ) {
    saveExitRules(workflowId: $workflowId, workflowType: $workflowType, rules: $rules) {
      workflowId
      rules {
        __typename
      }
    }
  }
`;
